import getAxiosInstance from './axiosInstance';
import handleError from './format-error';

const STEPS_BASE = '/steps';
const axios = getAxiosInstance();

const editStep = async ({ id, form, options } = {}) => {
  try {
    const { data } = await axios.put(`${STEPS_BASE}/${id}`, form);
    return { data };
  } catch (error) {
    const err = handleError(error, options);
    return { error: err };
  }
};
const getStepById = async ({ id, lng, forPublic, options = {} } = {}) => {
  try {
    const { data } = await axios.get(`${STEPS_BASE}/${id}`, {
      params: { lng, forPublic },
    });
    return { data };
  } catch (error) {
    const err = handleError(error, options);
    return { error: err };
  }
};

const getStepsContent = async ({ options, lng, stage }) => {
  try {
    const { data } = await axios.get(`${STEPS_BASE}`, {
      params: { lng, stage },
    });
    return { data };
  } catch (error) {
    const err = handleError(error, options);
    return { error: err };
  }
};

const updateSteps = async ({ options, data }) => {
  try {
    // change this when the back its ready!
    // const { data } = await axios.get(`${STEPS_BASE}`);
    return { data };
  } catch (error) {
    const err = handleError(error, options);
    return { error: err };
  }
};

export { getStepsContent, editStep, getStepById, updateSteps };
